import { last, startCase } from 'lodash-es';

export const nameToLabel = (name: string | string[]): string => {
  if (typeof name === 'string') {
    return startCase(last(name.split('.')) || name);
  }
  if (Array.isArray(name)) {
    return nameToLabel(last(name || []) || '');
  }
  return name;
};
